import { Spin } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import {
  HeaderControls,
  HeaderControlsInner,
  HeaderInput,
  StyledHeader,
  Wrapper,
  HeaderSearchWrapper,
  Button,
  LanguageRadioGroupWrapper,
  StyledCheckbox,
  CheckboxWrapper,
  CheckboxLabel,
} from './styles';

import { SearchIcon } from '../../images/search';
import { ToggleLanguage } from './toggle-language';
import { NavMenu } from './nav-menu';
import { UserInfo } from './user-info';

type Props = {
  term: string;
  searchByChargePointName: boolean;
  loading: boolean;
  firstName: string;
  lastName: string;
  onSearch: () => Promise<void>;
  onCheckboxChange: (e: CheckboxChangeEvent) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export function Header({
  term,
  searchByChargePointName,
  loading,
  firstName,
  lastName,
  onSearch,
  onCheckboxChange,
  onInputChange,
}: Props) {
  return (
    <StyledHeader>
      <Wrapper>
        <HeaderControls>
          <HeaderControlsInner>
            <HeaderSearchWrapper>
              <HeaderInput
                placeholder="Поиск"
                allowClear
                value={term}
                onChange={onInputChange}
                onPressEnter={onSearch}
                prefix={<SearchIcon />}
              />
              <CheckboxWrapper>
                <StyledCheckbox
                  checked={searchByChargePointName}
                  onChange={onCheckboxChange}
                >
                  <CheckboxLabel>Поиск по номеру ЭЗС</CheckboxLabel>
                </StyledCheckbox>
              </CheckboxWrapper>
              {!!term && (
                <Spin spinning={loading}>
                  <Button onClick={onSearch}>Найти</Button>
                </Spin>
              )}
            </HeaderSearchWrapper>
            <NavMenu />
          </HeaderControlsInner>
        </HeaderControls>
        <UserInfo firstName={firstName} lastName={lastName} />
        <LanguageRadioGroupWrapper>
          <ToggleLanguage />
        </LanguageRadioGroupWrapper>
      </Wrapper>
    </StyledHeader>
  );
}
